<template>
  <v-container>
    <v-layout column>
      <v-flex grow>
        <v-alert
          v-model="isError"
          dismissible
          type="error"
          transition="fade-transition"
        >
          {{ errMessage }}
        </v-alert>
      </v-flex>
      <v-flex>
        <h1>{{ action }} User</h1>
      </v-flex>
      <v-flex>
        <v-form @submit="submit">
          <v-layout column>
            <v-flex>
              <v-text-field
                v-model="email"
                label="Email Address"
                required
                :error-messages="errors.email"
                id="email"
                @focus="inputFocus"
                :disabled="action === 'Edit'"
              ></v-text-field>
              <v-select
                v-model="role"
                :items="roles"
                label="Role"
                id="role"
                :disabled="role_initial !== null"
                v-if="userID !== null"
              />
              <component
                :is="currentComponent"
                :admin="true"
                :showGender="true"
                :userID="userID">
              </component>
              <v-text-field
                v-model="password"
                label="Password"
                type='password'
                required
                :error-messages="errors.password"
                id="password"
                @focus="inputFocus"
              ></v-text-field>
              <v-text-field
                v-model="confirm"
                label="Confirm Password"
                type='password'
                required
                :error-messages="errors.confirm"
                id="confirm"
                @focus="inputFocus"
              ></v-text-field>
            </v-flex>
            <v-flex xs3>
              <v-btn
                block
                type="submit"
                id="submit"
              >
                {{ userID === null ? 'Save' : 'Update Password' }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import SetupChurchMember from '../../setup-church-member'
import SetupChurchStaff from '../../setup-church-staff'
import SetupAdmin from '../../setup-admin'

export default {
  data: () => ({
    email: null,
    password: null,
    confirm: null,

    role: null,
    role_initial: null,
    roles: [
      { text: 'Church Staff', value: 'church-staff' },
      { text: 'Church Member', value: 'church-member' },
      { text: 'Admin', value: 'admin' }
    ],

    isError: false,
    errMessage: null,
    errors: {
      email: null,
      password: null,
      confirm: null
    }
  }),
  computed: {
    userID: function () {
      if (this.$route.params.id === 'new') {
        return null
      } else {
        return this.$route.params.id
      }
    },
    action: function () {
      if (this.userID === null) {
        return 'Add'
      } else {
        return 'Edit'
      }
    },
    currentComponent: function () {
      if (this.role === null) {
        return null
      } else {
        return 'setup-' + this.role
      }
    }
  },
  mounted: function () {
    // If we're making a new user, we're done
    if (this.userID === null) {
      return
    }

    // Otherwise, we need to load data for the user
    var _this = this
    this.axios.get('/auth/users/' + this.userID)
      .then(function (res) {
        let user = res.data[0]

        _this.email = user.local.email
        _this.role = _this.role_initial = user.roles
      })
      .catch(this.$root.apiErrorHandler(function (msg, errors, err) {
        // If our error is a 404, that means we got a bogus user ID value and
        // we can safely abort back to user listing page. Otherwise, we want
        // to render our error message.
        if (err && err.response && err.response.status === 404) {
          return _this.$router.push('/admin/users')
        } else {
          _this.errMessage = msg
          _this.isError = true
        }
      }))
  },
  methods: {
    submit: function (ev) {
      ev.preventDefault()

      var _this = this

      // Set up the proper request based on whether we're editing or creating
      let url = '/auth/users'
      let method = 'POST'
      if (this.userID !== null) {
        url = '/auth/users/' + this.userID + '/password'
        method = 'PUT'
      }

      this.axios.request({
        method,
        url,
        data: {
          email: this.email,
          password: this.password,
          confirm: this.confirm
        }
      })
        .then(function () {
          _this.$router.push('/admin/users')
        })
        .catch(this.$root.apiErrorHandler(function (msg, errors) {
          _this.errMessage = msg
          _this.errors = errors
          _this.isError = true
        }))
    },
    inputFocus (ev) {
      // Clear any errors for an input when it receives focus
      if (ev.target && ev.target.id) {
        this.errors[ev.target.id] = null
      }
    }
  },
  components: {
    SetupChurchStaff,
    SetupChurchMember,
    SetupAdmin
  }

}
</script>
